const BASE_URL = "https://senutour.com/api";

const authHeaders = () => ({
  "Content-Type": "application/json",
  ...(getToken() ? { Authorization: `Bearer ${getToken()}` } : {}),
});

// ── HÉBERGEMENTS ──────────────────────────────────────────────
export const getHotels = async (filtres = {}) => {
  const params = new URLSearchParams();
  if (filtres.ville && filtres.ville !== "toutes") params.append("ville", filtres.ville);
  if (filtres.prixMax) params.append("prixMax", filtres.prixMax);
  if (filtres.etoiles) params.append("etoiles", filtres.etoiles);
  if (filtres.tri) params.append("tri", filtres.tri);
  if (filtres.type) params.append("type", filtres.type);

  const res = await fetch(`${BASE_URL}/hotels?${params.toString()}`);
  if (!res.ok) throw new Error("Erreur lors du chargement");
  return res.json();
};

export const getHebergements = async (filtres = {}) => {
  return getHotels(filtres);
};

export const getHotelById = async (id) => {
  const res = await fetch(`${BASE_URL}/hotels/${id}`);
  if (!res.ok) throw new Error("Hébergement non trouvé");
  return res.json();
};

export const getHebergementById = async (id) => {
  return getHotelById(id);
};

// ── AUTH ──────────────────────────────────────────────────────
export const login = async ({ email, password }) => {
  const res = await fetch(`${BASE_URL}/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Erreur de connexion");
  localStorage.setItem("token", data.token);
  localStorage.setItem("user", JSON.stringify(data.user));
  return data;
};

export const register = async (formData) => {
  const res = await fetch(`${BASE_URL}/auth/register`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(formData),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Erreur d'inscription");
  localStorage.setItem("token", data.token);
  localStorage.setItem("user", JSON.stringify(data.user));
  return data;
};

export const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
};

export const getCurrentUser = () => {
  const user = localStorage.getItem("user");
  return user ? JSON.parse(user) : null;
};

export const getToken = () => localStorage.getItem("token");

// ── RÉSERVATIONS ──────────────────────────────────────────────
export const createReservation = async (data) => {
  const res = await fetch(`${BASE_URL}/reservations`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify(data),
  });
  const result = await res.json();
  if (!res.ok) throw new Error(result.message || "Erreur lors de la réservation");
  return result;
};

export const getMesReservations = async () => {
  const res = await fetch(`${BASE_URL}/reservations/mes-reservations`, {
    headers: authHeaders(),
  });
  if (!res.ok) throw new Error("Erreur lors du chargement des réservations");
  return res.json();
};

export const annulerReservation = async (id) => {
  const res = await fetch(`${BASE_URL}/reservations/${id}/annuler`, {
    method: "PATCH",
    headers: authHeaders(),
  });
  const result = await res.json();
  if (!res.ok) throw new Error(result.message || "Impossible d'annuler");
  return result;
};